import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5mavqe5gr4: FaireBrandEntity = {
  token: "b_5mavqe5gr4",
  type: "brand",
  name: "Bene Chocolate",
  avatarUrl:
    "https://cdn.faire.com/fastly/46a4c35dfe7a97dbae34dc159f55cb48ca7d927bfa6fe45e01050a6d2d49e795.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ebdb360a871be9dd182feea2da1cbf2d211bd336bbf8148194dc75d31ec5a5f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/46a4c35dfe7a97dbae34dc159f55cb48ca7d927bfa6fe45e01050a6d2d49e795.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ebdb360a871be9dd182feea2da1cbf2d211bd336bbf8148194dc75d31ec5a5f.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 130,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Bene is a line of better-for-you chocolates that are organic, low in sugar, naturally sweetened, plant-based, taste like traditional candy, and benefit the body and mind with stress-melting adaptogens and brain-boosting mushrooms.",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:28:42.333Z",
    importedBy: "entity-db-cli",
  },
};
